import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Promo(props) {
    return (
        <SvgIcon {...props}>
            <path d="M23.5 29.3c-3.5 0-6.3-2.8-6.3-6.3s2.8-6.3 6.3-6.3 6.3 2.8 6.3 6.3-2.9 6.3-6.3 6.3zm0-10.6c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-2-4.3-4.3-4.3zM5.4 27.6c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L25.9 4.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4L6.1 27.3c-.2.2-.4.3-.7.3zm3.1-12.3C5 15.3 2.2 12.4 2.2 9S5 2.7 8.5 2.7s6.3 2.8 6.3 6.3-2.9 6.3-6.3 6.3zm0-10.6C6.1 4.7 4.2 6.6 4.2 9s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-2-4.3-4.3-4.3z" />
        </SvgIcon>
    );
}

Promo.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Promo;
